<template>
  <b-container fluid>
    <b-row>
      <b-col class="top_bar" />
    </b-row>
    <b-row
      ><b-col
        ><div class="page_title">{{ userType }}Profile</div></b-col
      ></b-row
    >
    <b-row v-if="profileData">
      <b-col class="col-auto">
        <b-row
          ><p>{{ profileData.first }} {{ profileData.last }}</p></b-row
        >
        <b-row
          ><p>{{ profileData.email }}</p></b-row
        >
        <b-row
          ><p>{{ profileData.dob }}</p></b-row
        >
        <b-row
          ><p>{{ profileData.phone }}</p></b-row
        >
        <b-row
          ><p>
            {{ profileData.address.street }} {{ profileData.address.unit }}
            {{ profileData.address.city }}, {{ profileData.address.state }}
            {{ profileData.address.zip }}
          </p></b-row
        >
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <avatar
              class="avatar"
              :avatar="profileData.avatar"
              :width="8"
              @click.native="editAvatar"
            />
            <vue-image-crop-upload
              v-model="editingAvatar"
              @crop-success="uploadAvatar"
              lang-type="en"
              :width="200"
              :height="200"
              img-format="png"
            ></vue-image-crop-upload>
          </b-col>
        </b-row>
        <b-row v-if="uploadAvatarError">
          <b-col
            ><div class="tsny_status-text">
              An error occurred uploading your avatar
            </div></b-col
          >
        </b-row>
      </b-col>
      <b-col v-if="isAdmin">
        <b-button
          class="tsny_button tsny_button-cancel"
          @click="$bvModal.show('deleteAccountModal')"
          >Delete Account</b-button
        >
      </b-col>
      <delete-account-modal :user="requestUser" />
    </b-row>
  </b-container>
</template>

<script>
import AccountRestService from "../../services/rest/services/AccountRestService";
import { mapGetters } from "vuex";
import StoreConstants from "../../store/services/StoreConstants";
import DeleteAccountModal from "../../components/Profile/DeleteAccountModal";
import VueImageCropUpload from "vue-image-crop-upload";
import Avatar from "../../components/Avatar";

export default {
  name: "Profile",
  components: { Avatar, DeleteAccountModal, VueImageCropUpload },
  props: {
    user: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: StoreConstants.GETTERS.IS_ADMIN,
      isStaff: StoreConstants.GETTERS.IS_STAFF,
      vuexUser: StoreConstants.GETTERS.USER
    }),
    requestUser: function() {
      return this.user || this.vuexUser;
    },
    userType: function() {
      return this.isStaff ? null : "Student ";
    }
  },
  data: function() {
    return {
      deleteError: false,
      profileData: null,
      editingAvatar: false,
      uploadAvatarError: null
    };
  },
  mounted: function() {
    return AccountRestService.getProfile(this.requestUser)
      .then(res => {
        this.profileData = res.data;
      })
      .catch(err => {
        console.log(err.response);
      });
  },
  methods: {
    editAvatar() {
      this.editingAvatar = !this.editingAvatar;
    },
    uploadAvatar(imgDataUrl) {
      let $comp = this;

      $comp.uploadAvatarError = false;

      return AccountRestService.uploadAvatar({
        email: $comp.profileData.email,
        avatar: imgDataUrl
      })
        .then(() => {
          $comp.profileData.avatar = imgDataUrl;
        })
        .catch(err => {
          console.error(err);
          $comp.uploadAvatarError = true;
        });
    }
  }
};
</script>

<style scoped>
p {
  padding-left: 60px;
}

.avatar:hover {
  cursor: pointer;
}
</style>
